module.exports = __webpack_public_path__ + "img/ic-arrow-link-white.05f6ad4b.svg";